import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { ROLES } from 'globalconfig/constants/keys';
import { subscriptionTier_options } from './config';
import { hasRestrictedRole, hasEnabledFeature } from 'globalutils/fmUtils';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({}) => {
  return {
    leftform_subscriptionTier_options: {
      [SERVICE_PROVIDERS.EM]: () => subscriptionTier_options[SERVICE_PROVIDERS.EM],
      [SERVICE_PROVIDERS.TP]: () => subscriptionTier_options[SERVICE_PROVIDERS.TP],
      default: () => subscriptionTier_options['default'],
    },
    leftform_fields: {
      [SERVICE_PROVIDERS.CLUTCH]: () => false,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => false,
      default: () => true,
    },
    leftform_fields_rolebased: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER]),
      default: () => false,
    },
    leftform_oldviewAlign: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    rightform_fields_speedLimit: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasEnabledFeature('cameraIntegrationEnabled'),
      default: () => false,
    },
    rightform_fields_zohoId: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER]),
      default: () => false,
    },

    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
